import React, { useState } from "react";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyle";
import { MdEmail } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const ForgotPassword = () => {
  const MailIcon = MdEmail as React.FC<React.SVGProps<SVGSVGElement>>;
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { forgotPassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const success = await forgotPassword(email);
    setIsLoading(false);
    if (success) {
      navigate("/reset-password", { state: { email } });
    }
  };

  return (
    <div className={GlobalStyles.containerCenter}>
      <div className={GlobalStyles.formContainer}>
        <div className={GlobalStyles.formHeader}>
          <h2 className={GlobalStyles.formHeaderTitle}>Forgot Password?</h2>
          <p className={GlobalStyles.formHeaderSubtitle}>
            Enter your registered email and we'll send you a one-time OTP to
            reset your password.
          </p>
        </div>

        <form className="p-5" onSubmit={handleSubmit}>
          <div className={GlobalStyles.formGroup}>
            <label htmlFor="email" className={GlobalStyles.label}>
              Email Address
            </label>
            <div className={GlobalStyles.inputWrapper}>
              <MailIcon className={GlobalStyles.inputIcon} />
              <input
                id="email"
                type="email"
                placeholder="Enter your email"
                className={GlobalStyles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`${GlobalStyles.buttonPrimary} !w-full mt-5 ${
              isLoading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isLoading ? "Sending OTP..." : "Send OTP"}
          </button>

          <div
            className={`mt-6 text-center ${CommonClasses.textXs} ${CommonClasses.textGray}`}
          >
            Remember your password?{" "}
            <Link to="/login" className={GlobalStyles.linkAccent}>
              Back to Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
